










































































    import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
    import Util from '../../lib/util'
    import AbpBase from '../../lib/abpbase'
    import AnnualManagementPlan from '../../store/entities/annualmanagementplan'
    import appconst from '../../lib/appconst'
 
    
     
    
    @Component
    export default class EditAnnualManagementPlan extends AbpBase{

            get ampdlist(){

            return this.$store.state.annualmanagementplan.ampdlist;
        }
        
        @Prop({type:Boolean,default:false}) value:boolean;
    
        user:AnnualManagementPlan=new AnnualManagementPlan();
         
        efname:"";
        
        save(){
           

            (this.$refs.userForm as any).validate(async (valid:boolean)=>{
                if(valid){
                    await this.$store.dispatch({
                        type:'annualmanagementplan/update',
                        data:this.user
                    });
                    (this.$refs.userForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input',false);
                }
            })
        }
        cancel(){
            (this.$refs.userForm as any).resetFields();
            this.$emit('input',false);
        }
        visibleChange(value:boolean){
              
            if(!value){
                this.$emit('input',value);
              
           
            }else{
         
           this.user=Util.extend(true,{},this.$store.state.annualmanagementplan.editAnnualManagementPlan);
              var eflist=this.$store.state.annualmanagementplan.hazardouswasteinformationlist;
              

              var th=this;
              eflist.forEach(item=>{
                    if(item.id== th.user.enterpriseinformationid){

                        th.efname=item.corporatename;
                    }
              })
             
             
               this.  getampdlist(this.user.id);  
             
                
            }
        }
        created() {
             
    
            
        }
        async getampdlist(aid){
       
                     await this.$store.dispatch({
                        type:'annualmanagementplan/getAnnualManagementPlanDetailAllByAid',
                        data:{annualmanagementplanid:aid}
                    });
         }
        userRule={
             
      
        }
        columns = [
     {
      
      title: this.L("危险废物"),
      key: "hazardouswaste",
       
    } ,
     {
      
      title: this.L("本年度计划量（吨）"),
      key: "thisyearweight",
     width:200,
    }   
,
     {
      
      title: this.L("上年度计划量（吨）"),
      key: "lastyearweight",
        width:200,
    }   
  ];

   
        
    }  

    

    
   
